import React from 'react';
import './Marker.css';
import { getPaceColor } from '../../utils/games';

const CustomMarker = (props) => {
    const { game, label, allGames = [] } = props;
    const { members, caddies, last_hole_played: lastHole, pace_formatted: currentPace, pace} = game;
    const [color, setColor] = React.useState('green');
    const [showInfo, setShowInfo] = React.useState(false);

    React.useEffect(() => {
        const fetchColor = async () => {
            const paceColor = await getPaceColor(game, allGames);
            setColor(paceColor);
        };
        fetchColor();
    }, [pace, game, allGames]);
    
    const labelToPropMapping = { "start_time" : "tee_time"}
    const extraWidth = {
        'caddie_name': '100px',
        'start_hole': '28px',
        'tracker_number': '36px'
    }
    const boarderRadius = {
        'caddie_name': '10%',
    }
    const centerLabel = label === 'tracker_number' || label === 'start_hole';
    const textColor = color === 'yellow' ? 'black' : 'white';
    const innerStyle = centerLabel
        ? { color: textColor, fontSize: 14, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }
        : { color: textColor, paddingLeft: 4, paddingTop: 4, fontSize: 14 };

    return (
      <div className="marker"
        style={{
            backgroundColor: color,
            cursor: 'pointer',
            textAlign: (boarderRadius[label] || centerLabel) ? 'center' : undefined,
            width: extraWidth[label],
            borderRadius: boarderRadius[label]
        }}
        onMouseOver ={() => setShowInfo(true)}
        onMouseOut ={() => setShowInfo(false)}
        // title={name}
      >
        <div style={innerStyle}>
            {game[labelToPropMapping[label] || label] || 'N'}
        </div>
        {
            showInfo ? 

            <div style={{height: "200px", width: "250px", fontSize: 16, marginTop: -230, backgroundColor: "white", justifyContent: "center", alignContent: "center", alignItems: "center", padding: 10, borderColor: "green", borderWidth: 10, borderRadius: "10px"}}>
                <div style={{marginTop: 4, color: "black"}}>
                    Golfers: 
                    <div style={{fontSize: 14}}>
                        <ol>
                            {members.map((m) => <li>{`${m.first_name} ${m.last_name}`}</li>)}
                        </ol>
                    </div>
                </div>
                {
                    caddies.length > 0 &&
                    <div style={{marginTop: 4, color: "black"}}>
                        Caddies: 
                        <div style={{fontSize: 14}}>
                            <ol> 
                                {caddies.map((c) => <li>{`${c.first_name} ${c.last_name}`}</li>)}
                            </ol>
                        </div>
                    </div>
                }
                <div style={{marginTop: 4, color: "black", flexDirection: "row"}}>
                    Last Hole Played: <span style={{fontSize: 14}}>{lastHole}</span>
                </div>
                <div style={{marginTop: 4, color: "black", flexDirection: "row"}}>
                    Current Pace: <span style={{ color: color, fontSize: 14}}>{currentPace}</span>
                </div>
            
            </div>
            :
            <></>
        }
        
        </div>
    );
  };

  export default CustomMarker;